define('xApi/configuration/viewConstants',[],function () {

    var constants = {
        patterns: {
            email: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,6})+)$/
        }
    };

    return constants;

});
